import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { SmDown } from "../../components/GlobalComponents/customMediqQueries";

export const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(() => ({
    border: `1px solid #000066`,
    borderTop: 0,
    borderRight: 0,
    borderLeft: 0,
    "&:last-child": {
      borderBottom: 0,
    },
    background: "transparent",
  }));
  
export const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={
        <ArrowForwardIosSharpIcon
          sx={(theme) => ({ fontSize: "1.3rem", color: "#000066",[SmDown]:{fontSize:"0.9rem"} })}
        />
      }
      {...props}
    />
  ))(({ theme }) => ({
    color: "#000066",
    padding: theme.spacing(1),
    background: "transparent",
    flexDirection: "row-reverse",
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      transform: "rotate(90deg)",
    },
    "& .MuiAccordionSummary-content": {
      marginLeft: theme.spacing(1),
    },
    [SmDown]:{
     padding:theme.spacing(0.5)
    }
  }));
  
export const AccordionDetails = styled(MuiAccordionDetails)(() => ({
    padding: '5px 5px 10px 40px',
    color: "#000066",
    [SmDown]: {
      padding: '5px 0px 10px 20px',
    },
  }));